module.exports = __webpack_public_path__ + "712a60e249642e8c4552eb45494ff494.MP3";